import apiClient from "./apiClient";

// Use centralized API client for consistent error handling
const api = apiClient;

// Get organization info for join request (public endpoint)
export const getOrganizationForJoinRequest = async (searchQuery, searchType = null) => {
  let url = `/api/join-requests/organization/search?query=${encodeURIComponent(searchQuery)}`;
  if (searchType) {
    url += `&type=${searchType}`;
  }
  const response = await api.get(url);
  return response.data;
};

// Search organizations by name for autocomplete
export const searchOrganizationsByName = async (searchQuery) => {
  const response = await api.get(`/api/join-requests/organization/search?query=${encodeURIComponent(searchQuery)}&type=name`);
  return response.data;
};

// Create a join request
export const createJoinRequest = async (organizationId) => {
  const response = await api.post("/api/join-requests", {
    organizationId
  });
  return response.data;
};

// Get join requests for organization (admin only)
export const getJoinRequestsForOrganization = async (organizationId) => {
  const response = await api.get(`/api/join-requests/organization/${organizationId}/requests`);
  return response.data;
};

// Approve join request (admin only)
export const approveJoinRequest = async (requestId, adminResponse) => {
  const response = await api.post(`/api/join-requests/${requestId}/approve`, {
    adminResponse
  });
  return response.data;
};

// Reject join request (admin only)
export const rejectJoinRequest = async (requestId, adminResponse) => {
  const response = await api.post(`/api/join-requests/${requestId}/reject`, {
    adminResponse
  });
  return response.data;
};

// Get user's pending join requests
export const getUserPendingJoinRequests = async () => {
  const response = await api.get("/api/join-requests/user/pending");
  return response.data;
}; 